import type { SingleCheckoutState } from '../singleCheckoutSlice';

/**
 * Derive shipments from checkout data and update current selections.
 */
const deriveShipments = (state: SingleCheckoutState, desiredSelection?: { methodId: number; shipmentKey: string }) => {
  const {
    checkoutData: {
      brands,
    },
  } = state;

  state.shipments = brands.flatMap((brand) => {
    const multi = brand.shipments.length > 1;

    return brand.shipments.map((option, optionIndex) => {
      const existingSelectionId =
        desiredSelection?.shipmentKey === option.key
          ? desiredSelection.methodId
          : option.shippingMethodId;

      const selectedMethod =
        option.shippingMethods.find(({ id }) => id === existingSelectionId) ||
        option.shippingMethods[0];

      const messages = Object.values(option.messages).filter(Boolean);

      const shipment: SingleCheckoutState['shipments'][0] = {
        cartIds: option.cartIds,
        compatibleMethods: option.shippingMethods.filter(({ compatible }) => compatible),
        cost: selectedMethod?.cost,
        includesSurcharges: selectedMethod?.includesSurcharges,
        items: option.items,
        key: option.key,
        messages,
        multi,
        multiIndex: multi ? optionIndex + 1 : undefined,
        orgImageKey: brand.orgImageKey,
        orgImageType: brand.orgImageType,
        orgName: brand.orgName,
        selectedMethod,
        shipMethods: option.shippingMethods,
      };

      if (desiredSelection && option.key === desiredSelection.shipmentKey) {
        let selectedMethods = state.selections.shippingMethods || [];

        selectedMethods = selectedMethods.filter((m) => !m.cartIds.some((cartId) => option.cartIds.includes(cartId)));

        selectedMethods.push({
          cartIds: option.cartIds,
          methodId: existingSelectionId,
        });

        state.selections.shippingMethods = selectedMethods;
      }

      return shipment;
    });
  });

  // if we dont have an address and any shipment does not have at least one compatible shipping method
  const anyIncompatible = brands
    .some((brand) => brand.shipments
      .flatMap((s) => s.shippingMethods)
      .every((m) => !m.compatible));

  state.shipmentsNeedsAddress = !state.selections.shippingAddress && anyIncompatible;

  state.totalItemQuantity = brands
    .flatMap((b) => b.shipments)
    .flatMap((s) => s.items)
    .reduce((sum, item) => sum + item.quantity, 0);
};

export default deriveShipments;
